<script setup lang="ts">
import { EmbeddedChat } from '#pages/embedded-chat'

const targetEl = document.querySelector('[data-behavior~="chat/main-chat-window"]') as HTMLElement | null
const hasHeader = targetEl?.dataset.hasHeader !== 'false'
const isWritable = targetEl?.dataset.isWritable !== 'false'
const isWritableMobile = targetEl?.dataset.isWritableMobile === 'true'
</script>

<template>
  <Teleport :to="targetEl">
    <EmbeddedChat :hasHeader="hasHeader" :isWritable="isWritable" :isWritableMobile="isWritableMobile" />
  </Teleport>
</template>
